var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dialog-header"},[_c('img',{staticClass:"close",attrs:{"src":require("../images/close-icon.svg")},on:{"click":function($event){return _vm.$emit('close')}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }